/**
 * Created by orenm on 11/23/2014.
 */
define(function (require) {
    "use strict";

    var BaseCollection = require("collections/BaseCollection");
    var SnippetModel = require("connection-models/KPsTab/SnippetModel");
    var ApiResources = require("assets/data/apiResources.json");
    var CP_CONST = require("connection-const");

    var RecentSnippetsCollection = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        RecentSnippetsCollection = BaseCollection.extend({
            model: SnippetModel,
            resource: _.clone(ApiResources.ConnectionPanel.RecentArticles),
            modelsLimit: CP_CONST.RECENT.SNIPPET_LIMIT,

            initialize: function (options) {
                //this._initializeResource(options);
            },

            updateCollection: function (selectedKP) {

                if(!this._isValidModel(selectedKP)){
                    return;
                }
                this._performModelAddition(selectedKP);
            },

            _performModelAddition: function (model) {
                var found = this._getFromCollection(model.get("slug"));
                if(found) {
                    // re-arrange the model order.
                    this.remove(found, {"silent":true});
                    this.unshift(found, {"silent":true});
                }
                else {
                    this.unshift(model, {"silent":true});
                    this._sliceCollectionByLimit();
                }
            },

            _isValidModel: function (model) {
                return (model !== null);
            },


            _isValidOptions: function (options) {
                var isValid = true;

//                if(_.isEmpty(options) || (_.isEmpty(options.lang)) || (_.isEmpty(options.user))) {
//                    LEConnection.logger.error("Failed to initialize collection with these parameters:", "ArticleRecentCollection:_isValidOptions", options);
//                    isValid = false;
//                }

                return isValid;
            },

            _initializeResource: function (options) {
                    this.resource.url = this.resource.url.replace("{lang}", options.lang);
                    this.resource.url = this.resource.url.replace("{userId}", options.userId);
                    this.resource.url = this.resource.url.replace("{accountId}", options.accountId);
            },

            _sliceCollectionByLimit: function () {
                if(this._isOverLimit()) {
                    this.remove(this.last() ,{"silent":true});
                }

            },

            _getFromCollection: function (slug) {
                return this.findWhere({slug: slug});
            },
            
            _isOverLimit: function () {
                return (this.size() > this.modelsLimit);
            },

            fetch: function(options) {
                options = options || {};
                if(this._isValidOptions(options)){
                    this._initializeResource(options);
                    return BaseCollection.prototype.fetch.call(this, options);
                }else{
                    if(options.error){
                        options.error();
                    }
                }
            },

            parse: function (response, options) {
                if (_.isEmpty(response)) {
                    response = [];
                }
                return response;
            }
        });
    });

    return RecentSnippetsCollection;
});